<ng-container *ngIf="data$ | async as d">
	<apx-chart
		[chart]="chart.chart"
		[colors]="chart.colors || []"
		[dataLabels]="chart.dataLabels || {}"
		[fill]="chart.fill || {}"
		[grid]="chart.grid || {}"
		[legend]="chart.legend || {}"
		[markers]="chart.markers || {}"
		[plotOptions]="chart.plotOptions || {}"
		[series]="chart.series || []"
		[theme]="chart.theme || {}"
		[title]="chart.title || {}"
		[tooltip]="chart.tooltip || {}"
		[xaxis]="chart.xaxis || {}"
		[yaxis]="chart.yaxis || {}"
		*ngFor="let chart of [d]; trackBy: trackChart"
		class="chart-container"
	></apx-chart>
</ng-container>
